export default "__VITE_ASSET__BEJY8J_A__"